import AxiosRequestBuilder from '@/utils/axios-request-builder'
import { IAccruals } from '@/types/accruals'
import { Endpoints, urlBuilder } from '@/connectors/endpoints'
import { arrayMapper } from '@/mappers'
import { accrualsMap } from '@/mappers/accruals'

const getPersonalAccountAccruals = (moId: number, houseId: number, accountId: number) => {
  return new AxiosRequestBuilder<IAccruals[]>({
    url: urlBuilder(Endpoints.GET_ACCRUALS_WITH_PA_ID, String(moId), String(houseId), String(accountId)),
    method: 'get',
    responseMapperFunction: arrayMapper,
    responseMapper: accrualsMap
  }).exec().then((response) => response.data)
}

export default getPersonalAccountAccruals
